//creat test page

import { React, useState} from "react";
import { Box,Flex, Button} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import TaskTab from 'views/user/property-management/view/components/task';
import NoteTab from 'views/user/property-management/view/components/note';
import ReservationTab from 'views/user/property-management/view/components/reservation';
import CityTaxTab from 'views/user/property-management/view/components/city-tax';
import DocumentsTab from 'views/user/property-management/view/components/documents';
import ArrivalsTab from 'views/user/property-management/view/components/arrivals';
import { userController } from 'lib/user';

function PropertyDetail() {

    const { id } = useParams();
    const [propertypage, setPropertyPage] = useState('task');
    const {userDetail} = userController();
    const { getUser } = userDetail();

    const advanceGroup  = ["admin","office"];
    const appSettings = JSON.parse(localStorage.getItem("app_settings") || "{}");
    const documentsEnabled = appSettings.documents_enabled !== false;

    const PropertyPages = {
        "task": {"title": "Attività", "show":true, "content": <TaskTab id={id} title="Elenco Attività" />},
        "reservation": {"title": "Prenotazioni","show":advanceGroup.concat(["operation"]).includes(getUser.role), "content": <ReservationTab id={id} title="Elenco Prenotazioni" />},
        "city-tax": {"title": "Tassa di Soggiorno", "show":advanceGroup.includes(getUser.role),"content": <CityTaxTab id={id} title="Elenco Tassa di Soggiorno" />},
        "documents": {"title": "Documenti", "show":documentsEnabled && advanceGroup.includes(getUser.role),"content": <DocumentsTab id={id} title="Documenti Ospiti" />},
        "arrivals": {"title": "Arrivi", "show":advanceGroup.includes(getUser.role),"content": <ArrivalsTab id={id} title="Arrivi" />},
        "notes": {"title": "Note", "show":advanceGroup.concat(["operation"]).includes(getUser.role), "content": <NoteTab id={id} title="Elenco Note" Datatype="note" />},
        "instructions": {"title": "Istruzioni", "show":advanceGroup.concat(["operation"]).includes(getUser.role), "content": <NoteTab id={id} title="Elenco Istruzioni" Datatype="instruction" />}
    };

    const handlePageChange = (page) => {
        setPropertyPage(page);
    }
    return (
        <Box>
            <Box
            mt={5}
            >
                <Flex
                className='tab-list'
                flexDirection={{ base: "column", md: "row" }}
                flex={{ base: "1", md: "0" }}
                >
                    {Object.keys(PropertyPages).map((key, index) =>
                        PropertyPages[key].show && (
                            <Button
                                onClick={() => handlePageChange(key)}
                                variant={propertypage === key ? "solid" : "outline"}
                                colorScheme="blue"
                                className={"tab-title "+(propertypage === key ? "active" : "")}
                                flex="1"
                                minWidth="auto"
                                px="12px"
                                fontSize={{ base: "13px", md: "14px" }}
                                _focus={{ boxShadow: "none" }}
                                key={"tab_title_"+index}
                            >
                                {PropertyPages[key].title}
                            </Button>
                        )
                    )}
                </Flex>
            </Box>
            <Box
            className="tab-content"
            >
                {propertypage && PropertyPages[propertypage] && PropertyPages[propertypage].show && (
                    PropertyPages[propertypage].content
                )}
            </Box>
        </Box>
    );
}
export default PropertyDetail;
